// eslint-disable-next-line import/prefer-default-export
export const constants = {
  ALLOWED_POSTAL_CODES: [],
  BUNDLE_TYPE_1N1K: 'bundle-1n1k',
  BUNDLE_TYPE_3F2: 'bundle-3f2',
  DEFAULT_LOCATION: 1,
  DEFAULT_CATERING_LOCATION: null,
  DEFAULT_DELIVERY_METHOD: 1,
  DEFAULT_PAYMENT_METHOD: 1,
  DELIVERY_METHOD_TYPE_ONSITE: 1,
  DELIVERY_METHOD_TYPE_DELIVER: 2,
  DELIVERY_METHOD_TYPE_TAKEAWAY: 3,
  PAYMENT_METHOD_TYPE_INPERSON: 0,
  PAYMENT_METHOD_TYPE_VALITOR: 1,
  PAYMENT_METHOD_TYPE_AUR: 2,
  PAYMENT_METHOD_TYPE_KASS: 3,
  PAYMENT_METHOD_TYPE_VERIFONE: 4,
  PAYMENT_METHOD_TYPE_VALITORPAGE: 10,
  PAYMENT_METHOD_TYPE_INVOICE: 100,
  PRODUCT_TYPE_BUNDLE: 'bundle',
  OPTION_GROUP_TYPE_TOPPINGS: 'toppings',
  ORDER_STATUS_UNPAYED: 1,
  CATERING_STATUS_UNPAYED: 10,
  CATERING_READY_TIME_START: '11:30',
  CATERING_READY_TIME_END: '21:00',
  USER_ROLE_ID: 2,
  EMAIL_API_KEY: '',
  DATE_LOCALE_OPTIONS: {
    days: 'Sunnudagur_Mánudagur_Þriðjudagur_Miðvikudagur_Fimmtudagur_Föstudagur_Laugardagur'.split('_'),
    daysShort: 'Sun_Mán_Þri_Mið_Fim_Fös_Lau'.split('_'),
    months: 'Janúar_Febrúar_Mars_Apríl_Maí_Júní_Júlí_Ágúst_September_Október_Nóvember_Desember'.split('_'),
    monthsShort: 'Jan_Feb_Mar_Apr_Maí_Jún_Júl_Ágú_Sep_Okt_Nóv_Des'.split('_'),
    firstDayOfWeek: 0,
  },
};
